module.exports = __webpack_public_path__ + "static/media/image.05e95412.jpg";